import { render } from "./BoxTotalMoviment.vue?vue&type=template&id=79e3a108"
import script from "./BoxTotalMoviment.vue?vue&type=script&lang=js"
export * from "./BoxTotalMoviment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__